import { render } from "./HistoriasDetalle.vue?vue&type=template&id=0b2b42a5&scoped=true"
import script from "./HistoriasDetalle.vue?vue&type=script&lang=js"
export * from "./HistoriasDetalle.vue?vue&type=script&lang=js"

import "./HistoriasDetalle.vue?vue&type=style&index=0&id=0b2b42a5&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2b42a5"]])

export default __exports__